<template>
	<div class="controls">
		<div class="controls__title">How do you want to serve Jif?</div>
		<h2>How do you want to serve Jif?</h2>
		<div class="controls__form">
			<!-- <form aria-controls="results">
				<input
					type="radio"
					value="on-the-side"
					id="on-the-side"
					v-model="controls"
				/>
				<label for="on-the-side">As a side</label>
				<input
					type="radio"
					value="in-the-dish"
					id="in-the-dish"
					v-model="controls"
				/>
				<label for="in-the-dish">As an ingredient</label>
				<input type="radio" value="both" id="both" v-model="controls" />
				<label for="both">Surprise me</label>
			</form> -->
			<form aria-controls="results">
				<ul v-if="filterGroups">
					<li v-for="(group, index) in filterGroups" :key="index">
						<button
							type="button"
							:aria-controls="`group-${index}`"
							:aria-expanded="(controlsOpen == group) ? 'true' : 'false'"
							@click="openGroup(group)"
						>
							<h3>{{ group.title }} <span></span></h3>
						</button>
						<ul :id="`group-${index}`" v-show="controlsOpen == group">
							<li v-for="(filter, bindex) in group.filters" :key="bindex">
								<input
									type="checkbox"
									:value="filter.name"
									:id="filter.id"
									v-model="controls"
								/>
								<label :for="filter.id">
									{{ filter.name }}
								</label>
							</li>
						</ul>
					</li>
				</ul>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	name: "Controls",
	data() {
		return {
			controls: ['Portion Control'],
			controlsOpen: "",
			filterChangeRecord: false,
		};
	},
	props: {
		filterGroups: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		controls: {
			handler: function () {
				this.handleChange();
			},
			deep: true
		},
	},
	beforeMount() {
		this.$emit("controlChange", this.controls);
	},
	mounted () {
		// get parameter named filtergroup from URL
		const urlParams = new URLSearchParams(window.location.search);
		const filterGroup = urlParams.get('filtergroup');
		// if filtergrou parameter is present, open that group
		if (filterGroup) {
			this.controlsOpen = this.filterGroups.find(group => group.title === filterGroup);
		}
		const filter = urlParams.get('filter');
		if (filter) {
			if (filter === 'Portion Control') {
				// do nothing for the jif page
			} else {
				this.controls = [filter];
			}
		} else {
			this.controls = []; // reset for normal page
		}
	},
	methods: {
		handleChange() {
			this.$emit("controlChange", this.controls);
			if (typeof dataLayer === "object" && this.filterChangeRecord) {
				// eslint-disable-next-line
				dataLayer.push({
					event: "genericEvent",
					eventCat: "Jif Tool",
					eventAction: "filter",
					eventLabel: "Filter Select | " + this.controls.join(", "),
				});
			}
			this.filterChangeRecord = true; // skip recording the first filter change, because that's on load
		},
		openGroup(group) {
			if (this.controlsOpen === group) {
				this.controlsOpen = "";
			} else {
				this.controlsOpen = group;
			}
			if (this.controls.length > 0) {
				this.controls = [];
			}
		},
	},
};
</script>

<style lang="scss">
@import "../styles/_colors.scss";
@import "../styles/_variables.scss";
@import "../styles/_mixins.scss";
@import "../styles/_functions.scss";
@import "../styles/vendor/_index.scss";

.controls {
	padding: 0 2em;
	color: white;
	// margin-top: -1em;
	padding-bottom: 2em;
	@include breakpoint(large) {
		margin-top: 1em;
		padding-bottom: 0;
	}
	h2,
	h3 {
		margin-bottom: 0.5em;
		font-family: $slab;
		font-weight: 700;
		font-size: 1.2em;
		color: #fff;
		text-transform: unset;
		span::before {
			display: inline-block;
			font-size: 1.333em;
			position: relative;
			top: 0.05em;
		}
	}
	h3 {
		text-transform: uppercase;
	}
	button[aria-expanded="false"] {
		h3 {
			span::before {
				content: "+";
			}
		}
	}
	button[aria-expanded="true"] {
		h3 {
			span::before {
				content: "\2212";
			}
		}
	}
}
// .controls__logo {
// 	width: 80px;
// 	margin-right: 0.5em;
// 	svg {
// 		width: 100%;
// 		height: auto;
// 	}
// }
.controls__title {
	// font-size: em(18);
	// text-transform: uppercase;
	@include visually-hidden;
}
.controls__form {
	padding-left: 0.666em;
	position: relative;
	top: -0.125em;
	ul {
		list-style: none;
		margin: 0 0 1em 0;
		padding: 0;
	}
}
input {
	display: none;
}
label {
	display: block;
	margin-bottom: 0.125em;
	position: relative;
	font-family: $slab;
	font-weight: 500;
	font-size: 1em;
	color: white;
	&::before {
		content: "";
		display: inline-block;
		width: 18px;
		height: 18px;
		// border-radius: 9px;
		background-color: $red;
		border: 1px solid $yellow;
		left: -5px;
		top: 3px;
		position: relative;
	}
	&::after {
		content: "";
		position: absolute;
		background-color: white;
		left: -1px;
		top: 7px;
		width: 10px;
		height: 10px;
		// border-radius: 7px;
		display: block;
		opacity: 0;
		transition: opacity 100ms ease;
	}
	&:hover {
		&::before {
			background-color: $orange;
		}
	}
}
input:checked + label {
	&::after {
		// background-image: svg-uri('<svg height="14" width="14"><circle cx=7 cy="7" r="7" stroke="" stroke-width="0" fill="white" /></svg>');
		// background-size: 14px 14px;
		// background-position: center center;
		// // background-color: white;
		opacity: 1;
	}
}
</style>